'use client';

import * as React from 'react';
import {cn} from '@purpose/ui/lib/utils';

export interface MenuItemProps {
  children: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  disabled?: boolean;
  sx?: any;
  className?: string;
  label?: string;
  isFirst?: boolean;
  isLast?: boolean;
}

const MenuItem = ({
  children,
  onClick,
  disabled = false,
  sx,
  className,
  label,
  isFirst,
  isLast,
  ...props
}: MenuItemProps) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (!disabled && onClick) {
      onClick(e as React.MouseEvent<HTMLElement>);
    }
  };

  return (
    <button
      type="button"
      aria-label={label || 'Handling'}
      onClick={handleClick}
      disabled={disabled}
      className={cn(
        'flex h-9 w-full min-w-[160px] cursor-pointer items-center justify-between px-3 text-left text-sm',
        'focus:bg-gray-100 focus:text-gray-900 focus:outline-none',
        'hover:bg-gray-50 active:bg-gray-100',
        isFirst && 'rounded-t-md',
        isLast && 'rounded-b-md',
        'touch-manipulation', // Optimize for touch interactions
        disabled && 'cursor-not-allowed opacity-50',
        className
      )}
      style={sx}
      {...props}
    >
      {children}
    </button>
  );
};

export {MenuItem};
